// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1DurationSchema = z.object({
  hours: z.number().int(),
  minutes: z.number().int(),
  seconds: z.number().int(),
  formatted: z.coerce.string().min(1),
  total_hours: z.number(),
  total_seconds: z.number().int(),
  total_minutes: z.number().int(),
});
